module.exports = __webpack_public_path__ + "static/media/uk.435fa4aa.png";